import { copy } from './copy';
import { card } from './components/card';
import { link } from './components/link';
import { properties } from './properties';
import { alert } from './components/alert';
import { input } from './components/input';
import { label } from './components/label';
import { radio } from './components/radio';
import { AppSpecificCopy } from '@/themes';
import { colors } from './constants/colors';
import { button } from './components/button';
import { footer } from './components/footer';
import { legend } from './components/legend';
import { navbar } from './components/navbar';
import { spinner } from './components/spinner';
import { typography } from './constants/typography';
import { inputRange } from './components/inputRange';
import { progressBar } from './components/progressBar';
import { errorMessage } from './components/errorMessage';
import { productTemplateV2 } from './product-template-v2';
import { scrollableArea } from './components/scrollableArea';
import { productTemplate } from './components/productTemplate';
import { AppTheme as CoreAppTheme } from '@zopauk/react-components/types/components/styles/Theme';

export interface AppTheme extends CoreAppTheme {
  properties: typeof properties;
  copy: AppSpecificCopy;
  colors: typeof colors;
}

const themeJLMoney: AppTheme = {
  flexContainer: {
    className: 'jl-flex-container',
  },
  productTemplateV2,
  productTemplate,
  scrollableArea,
  errorMessage,
  progressBar,
  typography,
  inputRange,
  spinner,
  navbar,
  legend,
  button,
  colors,
  footer,
  label,
  input,
  alert,
  radio,
  link,
  card,
  copy,
  // New theming
  properties,
};

export default themeJLMoney;
